import { IGenericSlider } from "../GenericSlider";
import { ISlideFactoryGeneric } from "../ISlideFactory";
import { SecondScreenHelpParams, SecondSceenHelp2Slides } from "./SecondSceenHelp2Slides";
import { SecondSceenHelp2Slides2Screens } from "./SecondScreenHelp2Slides2S";

export enum SlideType
{
	FreeGameBonus,
	FreeGamePlusOne,

	BigFreeGameBonus,
	BigFreeGamePlusOne,

	HoldAndSpinLeft,
	HoldAndSpinRight,

	Wild,

	ExpandingWildBulkLeft,
	ExpandingWildBulkRight,

	ExpandingWildReelLeft,
	ExpandingWildReelRight,

	DiamondSpin,

	TurboPlay,
	GameTitle,
	GameTitleJackpotDisplay
}
